export default (state = {}, action) => {
  switch (action.type) {
    case "FETCH_TIME_LEFT":
      return {
        timeleft: action.payload.timeleft,
        warehouse_is_open_tomorrow: action.payload.warehouse_is_open_tomorrow,
        warehouse_is_open: action.payload.warehouse_is_open
      };
      break;
    default:
      return state;
  }
};
